import Socials from "../components/Socials";
import Title from "../components/Title";
import Subtitle from "../components/Subtitle";
import Illustration from "../components/Illustration";
import Paragraph from "../components/Paragraph";

export default function Contact() {
    return (
        <>
            <section id="contact" className="contact-section">
                <div className="contact-container">

                    <div className="contact-content">
                        <div className="contact-text-content">
                            <Title headingLevel={2} size="L">
                                Let's <i>Chat</i>
                            </Title>

                            <Subtitle>INTERESTED IN WORKING TOGETHER?</Subtitle>

                            <Paragraph>
                                <p>
                                    I'd love to chat about your next project! Send me an email and let's get the conversation started.
                                </p>
                            </Paragraph>

                            <div className="contact-socials">
                                <Socials />
                            </div>
                        </div>

                        <Illustration className="contact-illustration" />
                    </div>

                    <div className="contact-info">
                        <a href="mailto:hello@laurenabramsky.com">hello@laurenabramsky.com</a>
                        <a href="https://laurenabramsky.com" className="contact-link">laurenabramsky.com</a>
                        <p>London | Remote</p>
                    </div>
                </div>
            </section>
        </>
    );
}

